import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import ErrorBoundary from '../components/ErrorBoundary';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  .nf-page {
    font-family: 'Inter', system-ui, sans-serif;
    background: #0a0f1e;
    min-height: calc(100vh - 80px); /* minus navbar approximately */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #e2e8f0;
    text-align: center;
  }
  .nf-inner {
    max-width: 500px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(99,102,241,0.18);
    border-radius: 24px;
    padding: 48px 32px;
    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  }
  .nf-404 {
    font-size: 5rem;
    font-weight: 900;
    line-height: 1;
    background: linear-gradient(135deg, #818cf8, #4f46e5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 24px;
    letter-spacing: -0.05em;
  }
  .nf-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #f1f5f9;
    margin-bottom: 16px;
  }
  .nf-subtitle {
    font-size: 15px;
    color: #94a3b8;
    line-height: 1.6;
    margin-bottom: 32px;
  }
  .nf-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 28px;
    background: linear-gradient(135deg, #6366f1, #4f46e5);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    font-family: inherit;
    transition: all 0.2s;
    box-shadow: 0 4px 14px rgba(99,102,241,0.3);
    cursor: pointer;
  }
  .nf-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(99,102,241,0.45);
  }
`;

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <ErrorBoundary>
            <div className="nf-page">
                <style>{STYLES}</style>
                <div className="nf-inner">
                    <div className="nf-404">404</div>
                    <h1 className="nf-title">Looks like you're lost in space!</h1>
                    <p className="nf-subtitle">
                        The page you're looking for doesn't exist, has been moved, or you might have mis-typed the URL.
                    </p>
                    <button className="nf-btn" onClick={() => navigate('/')}>
                        ← Take Me Home
                    </button>
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default NotFound;
